var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.totalCart
      ? _c("div", [
          _c("div", { staticClass: "main-title" }, [
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.getTranslation(
                    "order-content",
                    "order_cart_info_page_title"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "order-summary__body mt-5" }, [
              _c(
                "div",
                { staticClass: "custom-table" },
                [
                  _c(
                    "div",
                    { staticClass: "row custom-table__head d-none d-sm-flex" },
                    [
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "custom-table__head--elem" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getTranslation("product-list-vue", "program")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-table__head--elem text-sm-right",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getTranslation("front", "quantity"))
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-table__head--elem text-sm-right",
                          },
                          [_vm._v(_vm._s(_vm.getTranslation("front", "price")))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-table__head--elem text-sm-right",
                          },
                          [_vm._v(_vm._s(_vm.getTranslation("front", "total")))]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.products, function (product) {
                    return _vm.totalPrice[product.id] ||
                      _vm.hasSubscriptionCustomization(product.id) ||
                      _vm.totalPerpetualUpgrade[product.id] ||
                      _vm.leaseProlongPrice[product.id]
                      ? [
                          _vm.hasLicenses(
                            _vm.getQtyName("lease", "cloud"),
                            product.id
                          )
                            ? _c(
                                "div",
                                [
                                  _c("cart-info-licences", {
                                    attrs: {
                                      product: product,
                                      licenceType: _vm.getQtyName(
                                        "lease",
                                        "cloud"
                                      ),
                                      translate: "cloud_time_licences_product",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasSubscriptionCustomization(product.id)
                            ? [
                                _c("cart-info-subscription-customization", {
                                  attrs: {
                                    product: product,
                                    licenceType: _vm.getQtyName(
                                      "lease",
                                      "cloud"
                                    ),
                                    translate: "cloud_time_licences_product",
                                  },
                                }),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.totalPerpetualUpgrade[product.id]
                            ? _c(
                                "div",
                                [
                                  _c("cart-info-perpetual-upgrade", {
                                    attrs: { product: product },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.leaseProlongPrice[product.id]
                            ? [
                                _c("div", { staticClass: "custom-table" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row no-gutters custom-table__body",
                                    },
                                    [
                                      _vm._l(
                                        _vm.$store.state.cart.leaseProlong[
                                          product.id
                                        ].info,
                                        function (program) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-4 custom-table__title d-sm-none",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-table__title--elem",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getTranslation(
                                                          "product-list-vue",
                                                          "program"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-8 col-sm-6" },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "custom-table__body--elem",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.getProgramCartName({
                                                        id: program.id,
                                                        product: product.id,
                                                        type: "prolonged_subscription",
                                                      })
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-4 custom-table__title d-sm-none",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-table__title--elem",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getTranslation(
                                                          "front",
                                                          "quantity"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-8 col-sm-2 text-sm-right",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-table__body--elem",
                                                  },
                                                  [_vm._v(_vm._s(1))]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-4 custom-table__title d-sm-none",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-table__title--elem",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getTranslation(
                                                          "front",
                                                          "price"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-8 col-sm-2 text-sm-right",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-table__body--elem",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.leaseProlongPrice[
                                                          product.id
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-4 custom-table__title d-sm-none",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-table__title--elem",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getTranslation(
                                                          "front",
                                                          "total"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-8 col-sm-2 text-sm-right",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-table__body--elem",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.leaseProlongPrice[
                                                          product.id
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "col-12 d-sm-none custom-table__separator",
                                            }),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.hasSubscriptionPromo()
                    ? [
                        _c("div", { staticClass: "row no-gutters" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("h3", { staticClass: "order-summary__head" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.getTranslation(
                                      "promo2025",
                                      "subscription_promo_cart_summary_title",
                                      { product_name: _vm.leaseProductName() }
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "custom-table" }, [
                          _c(
                            "div",
                            {
                              staticClass: "row no-gutters custom-table__body",
                            },
                            [
                              _c("div", { staticClass: "col-9" }, [
                                _c(
                                  "div",
                                  { staticClass: "custom-table__body--elem" },
                                  [
                                    _c(
                                      "ul",
                                      _vm._l(
                                        _vm.promoProgramsInfo(),
                                        function (item) {
                                          return _c("li", [
                                            _vm._v(
                                              "x" +
                                                _vm._s(item.qty) +
                                                " " +
                                                _vm._s(item.name)
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-3 text-right" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.priceFormat(0, true, true)) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "col-12 d-sm-none custom-table__separator",
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("br"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grand-total" },
                    [
                      _vm.orderHasVat()
                        ? [
                            _c("div", { staticClass: "rounding" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-6 col-sm-6" }, [
                                  _c("div", { staticClass: "rounding__elem" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getTranslation("front", "total")
                                        ) + ":"
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-6 col-sm-6 text-right" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "rounding__elem" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.totalCart,
                                              true,
                                              true
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "rounding" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-6 " }, [
                                  _c("div", { staticClass: "rounding__elem" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getTranslation("front", "VAT")
                                        ) + ":"
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6 text-right" }, [
                                  _c("div", { staticClass: "rounding__elem" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(
                                          _vm.getVatPrice(),
                                          true,
                                          true
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderHasRounding()
                        ? [
                            !_vm.orderHasVat()
                              ? [
                                  _c("div", { staticClass: "rounding" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-6 col-sm-6" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "rounding__elem" },
                                              [
                                                _c("small", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getTranslation(
                                                        "front",
                                                        "total"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-6 col-sm-6 text-right",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "rounding__elem" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.priceFormat(
                                                      _vm.totalCart,
                                                      true,
                                                      true
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "rounding" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-6 " }, [
                                  _c("div", { staticClass: "rounding__elem" }, [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getTranslation(
                                            "front",
                                            "INVOICE_ROUNDING"
                                          )
                                        ) + ":"
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6 text-right" }, [
                                  _c("div", { staticClass: "rounding__elem" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.getRoundingSign()) +
                                        "\n                                    " +
                                        _vm._s(
                                          _vm.priceFormat(
                                            _vm.getRoundingPrice(),
                                            true,
                                            true
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row no-gutters" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c("h4", [
                            _vm._v(
                              _vm._s(
                                _vm.getTranslation("user-info", "grand_total")
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 text-right" }, [
                          _c("h4", [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(_vm.getGrandTotal(), true, true)
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                2
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.totalCart
      ? _c("div", [
          _c("div", { staticClass: "order-summary__empty" }, [
            _c("div", { staticClass: "order-summary__empty--icon" }, [
              _c("img", {
                attrs: { src: _vm.imgPath + "images/shop_icon.svg", alt: "" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "order-summary__empty--msg" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.getTranslation("order-content", "cart_empty")) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "order-summary__empty--hint",
              domProps: {
                innerHTML: _vm._s(
                  _vm.getTranslation("order-content", "cart_empty_message")
                ),
              },
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-order",
                attrs: { href: _vm.navigation.home },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.getTranslation("order-content", "return_to_shop")
                    ) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }